import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCurrentLocationXs = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.55228 15.2321L8.075 8.65707L1.5 7.17979L14.702 2.03003L9.55228 15.2321ZM8.9119 7.82018L4.91326 6.92176L12.9422 3.78989L9.81032 11.8188L8.9119 7.82018Z'
    />
  </svg>
);
export default SvgCurrentLocationXs;
